import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class DeleteAffiliateLiquidationCommand extends IRequestCommand<
  IDeleteAffiliateLiquidationResponse,
  ErrorDetails,
  IDeleteAffiliateLiquidationCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;
  override _commandUrl =
    'affiCheckingAccount/{checkingAccId}/deleteLiquidation/{liquidationId}';

  public override setParameters(
    parameters: IDeleteAffiliateLiquidationCommandParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{checkingAccId}',
      parameters.checkingAccountId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{liquidationId}',
      parameters.liquidationId.toString()
    );
  }
}

export interface IDeleteAffiliateLiquidationCommandParameters
  extends ICommandResponse {
  checkingAccountId: number;
  liquidationId: number;
}

export interface IDeleteAffiliateLiquidationResponse extends ICommandResponse {}
